module.exports = __webpack_public_path__ + "img/file-word.b712953d.svg";